var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg2Star = function Svg2Star(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,5C25.187,5,5,25.187,5,50s20.187,45,45,45s45-20.187,45-45S74.813,5,50,5z M50,90c-22.056,0-40-17.944-40-40   s17.944-40,40-40s40,17.944,40,40S72.056,90,50,90z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.759,
    cy: 41.599,
    r: 5.683
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.241,
    cy: 41.599,
    r: 5.683
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.578,65.68c-1.031,0.919-1.122,2.499-0.203,3.53c0.919,1.032,2.499,1.122,3.53,0.203c9.025-8.045,23.165-8.045,32.19,0   c0.477,0.425,1.071,0.634,1.663,0.634c0.688,0,1.374-0.282,1.867-0.836c0.919-1.031,0.828-2.611-0.203-3.53   C58.532,55.972,41.468,55.972,30.578,65.68z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg2Star, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2star.dc6356bf.svg";
export { ForwardRef as ReactComponent };